// import {
//   FacebookIcon,
//   InstagramIcon,
//   LinkedinIcon,
//   Youtube,
// } from "lucide-react";
// import { Separator } from "@/pages/newHome/ui/separator";
// import footer from "@/assets/newHome/footer.png";
// import layer1 from "@/assets/newHome/layer-1-1.png";

// // const footerLinks = [
// //   {
// //     title: "Features",
// //     links: [
// //       "Find Subcontractors",
// //       "Find Projects",
// //       "ROI Calculator",
// //       "Learn",
// //       "Feature goes here",
// //     ],
// //   },
// //   {
// //     title: "Property Types",
// //     links: [
// //       "Residential Property",
// //       "Commercial Property",
// //       "Society Property",
// //       "Office Property",
// //       "Store Property",
// //     ],
// //   },
// //   {
// //     title: "Resources",
// //     links: ["Explore", "How It Works", "Pricing", "Blogs", "FAQ"],
// //   },
// //   {
// //     title: "Quick Links",
// //     links: ["Sign Up", "Login", "Terms & Condition", "Privacy Policy"],
// //   },
// // ];

// export const FooterByAnima = (): JSX.Element => {
//   return (
//     <footer className="w-full bg-gradient-to-b from-white to-[#EEFFF2]">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-6 ">
//         {/* Logo Section */}
//         <div className="mb-8 md:mb-10">
//           <div className="flex  justify-between">
//             <img
//               src={layer1}
//               alt="Company Logo"
//               className="h-8 w-auto max-w-full"
//             />

//           <div className="flex-row sm:flex-col gap-10 footer-pages">
//             <h3>Sign Up</h3>
//             <h3>Login</h3>
//             <h3>Terms & Conditions</h3>
//             <h3>Privacy Policy</h3>
//           </div>
//           </div>
//         </div>

//         {/* Links Grid - Responsive columns */}
//         {/* <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 mb-8 md:mb-10">
//           {footerLinks.map((category, index) => (
//             <div key={index} className="space-y-3 sm:space-y-4">
//               <h3 className="font-bold text-charcoal text-base sm:text-lg">
//                 {category.title}
//               </h3>
//               <ul className="space-y-2 sm:space-y-3">
//                 {category.links.map((link, linkIndex) => (
//                   <li key={linkIndex}>
//                     <a
//                       href="#"
//                       className="text-lightGray hover:text-primary text-sm sm:text-base transition-colors duration-200"
//                     >
//                       {link}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div> */}

//         {/* Divider */}
//         <Separator className="w-full h-px bg-gray-200 my-4 md:my-6" />

//         {/* Copyright and Social Links */}
//         <div className="flex flex-col md:flex-row justify-between items-center gap-4 py-4">
//           <p className="text-lightGray text-sm sm:text-base text-center md:text-left">
//             ©2025 BuildMapper. All rights reserved
//           </p>

//           <div className="flex justify-center items-center space-x-4 sm:space-x-6">
//             <a
//               href="https://www.facebook.com/buildmapper1/"
//               className="text-primary hover:text-primary-dark transition-colors duration-200"
//               aria-label="Facebook"
//               target="_blank"
//             >
//               <FacebookIcon
//                 className="w-5 h-5 sm:w-6 sm:h-6 fill-current"
//                 stroke="none"
//               />
//             </a>
//             <a
//               href="https://www.instagram.com/buildmapper/"
//               className="text-primary hover:text-primary-dark transition-colors duration-200"
//               aria-label="Instagram"
//               target="_blank"
//             >
//               <InstagramIcon
//                 className="w-5 h-5 sm:w-6 sm:h-6"
//                 strokeWidth={1.5}
//               />
//             </a>
//             <a
//               href="https://www.linkedin.com/company/buildmapper/"
//               className="text-primary hover:text-primary-dark transition-colors duration-200"
//               aria-label="LinkedIn"
//               target="_blank"
//             >
//               <LinkedinIcon
//                 className="w-5 h-5 sm:w-6 sm:h-6 fill-current"
//                 stroke="none"
//               />
//             </a>
//             <a
//               href="https://www.youtube.com/@buildmapper9998"
//               className="text-primary hover:text-primary-dark transition-colors duration-200"
//               aria-label="YouTube"
//               target="_blank"
//             >
//               <Youtube className="w-5 h-5 sm:w-6 sm:h-6" />
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Footer Image - Responsive height */}
//       <img
//         src={footer}
//         alt="Footer decoration"
//         className="w-full h-auto max-h-48 object-cover"
//       />
//     </footer>
//   );
// };

import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  Youtube,
} from "lucide-react";
import { Separator } from "@/pages/newHome/ui/separator";
import footer from "@/assets/newHome/footer.png";
import layer1 from "@/assets/newHome/layer-1-1.png";
// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { Link } from "react-router-dom";
import { cn } from "@/pages/newHome/lib/utils";

export const FooterByAnima = (): JSX.Element => {
  const user = useSelector(
    (state: RootState) => state.rootReducer.userReducer.user
  );
  return (
    <footer className="w-full bg-gradient-to-b from-white to-[#EEFFF2] z-10 pointer-events-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        {/* Logo and Page Links */}
        <div className="mb-8 md:mb-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            {/* Logo */}
            <div className="flex pl-4 justify-start md:justify-start">
              <img
                src={layer1}
                alt="Company Logo"
                className="h-8 w-auto max-w-full"
              />
            </div>

            {/* Page Links */}
            <div
              className={cn(
                "text-left justify-start items-start gap-x-4 gap-y-2 pl-4 text-sm sm:text-base text-charcoal font-medium",
                !user
                  ? "grid grid-cols-2 md:flex md:flex-row md:items-center md:space-x-8 md:text-left"
                  : "grid grid-cols-1 md:flex md:flex-row md:items-center md:space-x-8 md:text-left"
              )}
            >
              {!user && (
                <div className="flex justify-start">
                  {/* <a
                    onClick={() => window.open("https://buildmapper.typeform.com/to/oVrzJex7", "_blank")}
                    className="cursor-pointer hover:text-primary transition-colors duration-200"
                  > */}
                  <Link
                  to="/auth/signup"
                  className="!no-underline hover:text-primary transition-colors duration-200"
                >
                    Sign Up
                  {/* </a> */}
                  </Link>
                </div>
              )}

              {!user && (
                <Link
                  to="/auth/login"
                  className="!no-underline hover:text-primary transition-colors duration-200"
                >
                  Sign In
                </Link>
              )}


              <Link
                to="/terms_and_conditions"
                className="!no-underline hover:text-primary transition-colors duration-200 whitespace-nowrap"
              >
                Terms & Conditions
              </Link>

              <Link
                to="/privacy_policy"
                className="!no-underline hover:text-primary transition-colors duration-200 whitespace-nowrap"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        {/* Divider */}
        <Separator className="w-full h-px bg-gray-200 my-4 md:my-6" />

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-4 py-4">
          <p className="text-lightGray text-sm sm:text-base text-center md:text-left">
            ©2025 BuildMapper. All rights reserved
          </p>

          <div className="flex justify-center items-center space-x-4 sm:space-x-6">
            <a
              href="https://www.facebook.com/buildmapper1/"
              className="text-primary hover:text-primary-dark transition-colors duration-200"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon
                className="w-5 h-5 sm:w-6 sm:h-6 fill-current"
                stroke="none"
              />
            </a>
            <a
              href="https://www.instagram.com/buildmapper/"
              className="text-primary hover:text-primary-dark transition-colors duration-200"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon
                className="w-5 h-5 sm:w-6 sm:h-6"
                strokeWidth={1.5}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/buildmapper/"
              className="text-primary hover:text-primary-dark transition-colors duration-200"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedinIcon
                className="w-5 h-5 sm:w-6 sm:h-6 fill-current"
                stroke="none"
              />
            </a>
            <a
              href="https://www.youtube.com/@buildmapper9998"
              className="text-primary hover:text-primary-dark transition-colors duration-200"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Youtube className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Decoration Image */}
      <img
        src={footer}
        alt="Footer decoration"
        className="w-full h-[200px] sm:h-auto max-h-48 object-cover sm:object-fill"
      />
    </footer>
  );
};
